import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { Container, Tile, GlobalStyle, InternalImage, PlayButton, HoverOverlay, } from "./GameTilesGrid.styled";
import { CustomThumbnail } from "../CustomThumbnail";
import GameTilePlayIcon from "../GameTile/GameTile.play";
var GameTilesGrid = function (_a) {
    var games = _a.games, onClick = _a.onClick;
    var containerRef = useRef(null);
    var _b = useState(8), columns = _b[0], setColumns = _b[1];
    var handleGameClick = function (game) {
        onClick(game);
    };
    useEffect(function () {
        var updateColumns = function () {
            if (containerRef.current) {
                var containerWidth = containerRef.current.offsetWidth;
                var tileWidth = 150;
                var calculatedColumns = Math.floor(containerWidth / tileWidth);
                var newColumns = Math.max(calculatedColumns, 3); // Minimum 3 columns
                setColumns(newColumns);
            }
        };
        var observer = new ResizeObserver(updateColumns);
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        updateColumns();
        return function () {
            if (containerRef.current)
                observer.unobserve(containerRef.current);
        };
    }, []);
    return (_jsxs(Container, { ref: containerRef, columns: columns, children: [_jsx(GlobalStyle, {}), games.map(function (game) { return (_jsxs(Tile, { onClick: function () { return handleGameClick(game); }, children: [game.customThumb && (_jsx(InternalImage, { src: game.urlThumb, alt: game.label })), !(game === null || game === void 0 ? void 0 : game.customThumb) && (_jsx(CustomThumbnail, { imageUrl: game.urlThumb, title: game.label, provider: game.provider })), _jsx(HoverOverlay, { children: _jsx(PlayButton, { children: _jsx(GameTilePlayIcon, {}) }) })] }, game.gameId)); })] }));
};
export default GameTilesGrid;
//# sourceMappingURL=GameTilesGrid.js.map